var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[(_vm.fileExists && _vm.prodImageDetail[0].folder)?_c('div',[_c('b-img',{attrs:{"src":`/images/pim/600/${_vm.prodImageDetail[0].folder}/${_vm.prodImageDetail[0].img}.jpg`}})],1):_c('div',[_c('img',{attrs:{"src":"/images/products/img-coming-soon.png","alt":"image"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }